// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 246 ? "component---src-pages-tsx" : chunkId) + "-" + {"246":"8a029634d4845c2aaf09","522":"86f622d7ec96da426215","577":"73ed78ea769ef3e6bae3","818":"dd3c9f2c6eabe965655b","927":"d75eb8a5ccc267d5b41e"}[chunkId] + ".js";
};